import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as DataAccessProductsActions from './data-access-products.actions';
import * as DataAccessProductsSelectors from './data-access-products.selectors';

@Injectable()
export class DataAccessProductsFacade {
  product$ = this.store.pipe(select(DataAccessProductsSelectors.getProduct));
  products$ = this.store.pipe(select(DataAccessProductsSelectors.getProducts));
  productLoading$ = this.store.pipe(select(DataAccessProductsSelectors.getActiveProductLoadingState));
  productError$ = this.store.pipe(select(DataAccessProductsSelectors.getActiveProductError));
  exhibitorProducts$ = this.store.pipe(select(DataAccessProductsSelectors.getProductExhibitorProducts));
  productProducts$ = this.store.pipe(select(DataAccessProductsSelectors.getProductProducts));

  constructor(private readonly store: Store) {}

  pageOpened(productUuid: string) {
    this.store.dispatch(DataAccessProductsActions.productOpened({ productUuid: productUuid }));
  }

  pageOpenedUnauthorized(productUuid: string) {
    this.store.dispatch(DataAccessProductsActions.productOpenedUnauthorized({ productUuid: productUuid }));
  }

  getProductById(productId: string) {
    return this.store.pipe(select(DataAccessProductsSelectors.getProductById, { productId }));
  }

  getProductsById(productIds: string[]) {
    return this.store.pipe(select(DataAccessProductsSelectors.getProductsById, { productIds }));
  }
}
